import React from 'react';
import type { AImageProps } from '../../atoms/AImage/AImage.types';
import type { AVideoProps } from '../../atoms/AVideo/AVideo.types';
import type { MButtonOverlayProps } from '../MButtonOverlay/MButtonOverlay.types';
import type { OModalMediaProps } from '../../organisms/OModalMedia/OModalMedia.types';
import type { ResponsiveImageSpec } from '../../utils/ImageUtils';

export enum MVideoThumbnailAriaLabel {
  DefaultPlay = 'Play video',
}

export enum MVideoThumbnailErrorMessage {
  ThumbnailFailed = 'The thumbnail could not be retrieved',
  /**
   * @deprecated Inline video playback removed in DUX-3022. This message is no longer used.
   * @internal Not for external consumer use. Will be removed in a future major version.
   */
  VideoFailed = 'Unable to load video',
}

export interface MVideoThumbnailProps extends React.HTMLAttributes<HTMLDivElement> {
  aImage?: AImageProps;
  /**
   * @deprecated Pass video data via `oModalMedia.aVideo` instead.
   * If provided without `oModalMedia`, the implementation synthesizes:
   * `{ type: 'video', aVideo }`
   * so existing callers continue to work.
   */
  aVideo?: AVideoProps;
  /** Play button overlay rendered centered over the thumbnail. Defaults to a play icon button if not provided. */
  mButtonOverlay?: MButtonOverlayProps;
  /** Modal media data. When present, clicking the play button fires onModalOpen with this payload. */
  oModalMedia?: Partial<OModalMediaProps>;
  /**
   * Optional notification callback — fires when the play button is clicked and
   * oModalMedia (or the aVideo shim) resolves to a payload.
   * Not a control-flow dependency. OCarouselGalleryHero never passes this prop.
   * Wire to Storybook CSF3 fn() for Actions panel observability.
   */
  onModalOpen?: (data: Partial<OModalMediaProps>) => void;
  /** Responsive image specs for generating renditions. Uses built-in defaults if omitted. */
  renditionSpecs?: ResponsiveImageSpec[];
  /** Browser loading strategy for the thumbnail image. Defaults to `'lazy'`. */
  loading?: 'eager' | 'lazy';
}
